import { createContext, useContext, useState, useEffect } from "react";
import { login as loginService, logout as logoutService, getMe } from "../services/auth.service";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [usuario, setUsuario] = useState(null);
  const [cargando, setCargando] = useState(true);

  // Trae el usuario+permisos frescos del backend y actualiza estado/localStorage.
  // Se reutiliza en el montaje inicial y cada vez que la pestaña vuelve a estar
  // activa, para que cambios de permisos hechos desde "Permisos y roles" en
  // otra sesión/pestaña se reflejen sin tener que cerrar sesión.
  const refrescarUsuario = () => {
    const token = localStorage.getItem("token");
    if (!token) return;
    getMe()
      .then((me) => {
        setUsuario((prev) => {
          const base = prev || JSON.parse(localStorage.getItem("usuario") || "{}");
          const merged = { ...base, ...me };
          localStorage.setItem("usuario", JSON.stringify(merged));
          return merged;
        });
      })
      .catch(() => {});
  };

  useEffect(() => {
    const usuarioGuardado = localStorage.getItem("usuario");
    const token = localStorage.getItem("token");
    if (usuarioGuardado && token) {
      const parsed = JSON.parse(usuarioGuardado);
      setUsuario(parsed);
      refrescarUsuario();
    }
    setCargando(false);
  }, []);

  // Refresca permisos al volver a la pestaña (cambio de permisos hecho mientras
  // estaba en background) y periódicamente como red de seguridad adicional.
  useEffect(() => {
    const onVisible = () => {
      if (document.visibilityState === "visible") refrescarUsuario();
    };
    document.addEventListener("visibilitychange", onVisible);
    window.addEventListener("focus", onVisible);
    const intervalo = setInterval(refrescarUsuario, 5 * 60 * 1000);
    return () => {
      document.removeEventListener("visibilitychange", onVisible);
      window.removeEventListener("focus", onVisible);
      clearInterval(intervalo);
    };
  }, []);

  const login = async (email, password) => {
    const data = await loginService(email, password);
    localStorage.setItem("token", data.token);
    localStorage.setItem("usuario", JSON.stringify(data.usuario));
    setUsuario(data.usuario);
    return data;
  };

  const logout = async () => {
    await logoutService();
    setUsuario(null);
  };

  return (
    <AuthContext.Provider value={{ usuario, login, logout, cargando, refrescarUsuario }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
